var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.778.522a1.1 1.1 0 0 0-1.556 0l-7.7 7.7a1.1 1.1 0 0 0 1.556 1.556l.322-.322V16.7a1.1 1.1 0 0 0 1.1 1.1h2.2a1.1 1.1 0 0 0 1.1-1.1v-2.2a1.1 1.1 0 0 1 1.1-1.1h2.2a1.1 1.1 0 0 1 1.1 1.1v2.2a1.1 1.1 0 0 0 1.1 1.1h2.2a1.1 1.1 0 0 0 1.1-1.1V9.456l.322.322a1.1 1.1 0 0 0 1.556-1.556z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.75f2903bb7136a7a512cda09818c1878.svg";
export { ForwardRef as ReactComponent };